export const EVENT_SEND_EMAIL = "eventSendEmail"
export const EVENT_EDIT_BOT_FAIL = "eventEditBotFail"
export const EVENT_OPEN_WALLET_MODAL = "eventOpenWalletModal"
export const EVENT_WALLET_CONNECTED = "eventWalletConnected"
export const EVENT_WALLET_CONNECT_ERROR = "eventWalletConnectError"
export const EVENT_WALLET_MODAL_CLOSE = "eventWalletModalClose"
export const EVENT_WALLET_SWITCH_CHAINE = "eventWalletSwitchChain"